import 'cascading-drop-down-list';

onLoad();

export function onLoad(context = document) {
    context.querySelectorAll('.model-select-search-form, .registration-number-search-form').forEach(function (form) {
        form.addEventListener('success', function (e) {
            // Hide forms.
            context.querySelectorAll('#product-model-search-form').forEach(function(form2) {
                form2.classList.add('d-none');
            });

            // Get data from the event detail.
            var isCompatible = e.detail.data.isCompatible;
            var vehicleDescription = e.detail.data.vehicleDescription;
            var otherCompatibleListings = e.detail.data.otherCompatibleListings;

            // Show the response element.
            var responseElement = context.querySelector('#compatibility-checker-response');
            responseElement.querySelector('.current-vehicle').style.borderColor = isCompatible ? '#18AE03' : '#E30000';

            var vueScope = responseElement.$data;
            vueScope.isCompatible = isCompatible;
            vueScope.vehicleDescription = vehicleDescription;
            vueScope.otherCompatibleListings = otherCompatibleListings;

            responseElement.classList.remove('d-none');
        });
    });
}